var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.course)?[_c('div',{staticClass:"fill bg-blue"},[_c('course-top-header',{attrs:{"course":_vm.course}}),_c('course-header',{attrs:{"course":_vm.course}})],1),_c('router-view')]:_c('div',[_c('skeleton',{attrs:{"lines":7}}),_c('skeleton',{attrs:{"lines":20,"style-class":"mt-24"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }